<template>
  <div class="guanLianBox">
    <el-dialog v-loading="loading" :title="title" :visible.sync="jiesuanVisible" :close-on-click-modal="false"
      width="50%" center :before-close="submitClose">
      <div>
        <el-form :model="CKFormData" ref="CKFormData" :inline="false" label-width="100px" style="">
          <el-form-item>结算客户：{{ customer }}</el-form-item>
          <el-form-item>
            <span><span>费用合计：</span> <span style="color:red">{{ CKFormData.feeBalance }}</span> 元</span>
            <span style="margin-left:20px;"><span>附加：</span> <span style="color:red">
                <el-input @input="fujia" style="width:100px;" v-number-input.float="2" v-model="CKFormData.fujiafei"
                  size="mini"></el-input>
              </span> 元</span>
            <span style="margin-left:20px;"><span>减免：</span> <span style="color:red">
                <el-input @input="jianmian" style="width:100px;" v-number-input.float="2"
                  v-model="CKFormData.jianmianfei" size="mini"></el-input>
              </span> 元</span>
          </el-form-item>
          <el-form-item>
            <span><span>应收费用：</span> <span style="color:red">{{ CKFormData.yingshou }}</span> 元</span>
            <span style="margin-left:20px;"><span>费用备注：</span> <span style="color:red">
                <el-input style="width:200px;" :maxlength="50" v-model="CKFormData.beizhu" size="mini"></el-input>
              </span></span>
          </el-form-item>
          <hr>
          <el-form-item>
            付款方式：
            <div style="display:inline-block;margin:0 10px;" v-if="collectType.indexOf('1')!=-1"
              :class="this.JSway == 1?'active1':'active'" @click="YCclick(1)" v-show="disabledYC">
              <img src="@/assets/images/money01.png" alt="" style="height:25px;position:absolute;left:5px;top:6px">
              <span style="margin-left:35px">预存款 （余额：{{ CKFormData.money }}）</span>
              <!-- <div v-if="this.JSway == 1" class="active2"></div>
              <div v-if="this.JSway == 1" class="active3">√</div> -->
              <img src="@/assets/images/right.png" alt="" style="height:25px;position:absolute;right:-1px;bottom:-1px"
                v-if="this.JSway == 1" class="active3">
            </div>
            <div style="display:inline-block;margin:0 10px;" v-if="collectType.indexOf('2')!=-1"
              :class="this.JSway == 2?'active1':'active'" @click="YCclick(2)">
              <img src="@/assets/images/scan_pay.png" alt="" style="height:25px;position:absolute;left:5px;top:6px">
              <span style="margin-left:35px">扫码</span>
              <!-- <div v-if="this.JSway == 2" class="active2"></div>
              <div v-if="this.JSway == 2" class="active3">√</div> -->
              <img src="@/assets/images/right.png" alt="" style="height:25px;position:absolute;right:-1px;bottom:-1px"
                v-if="this.JSway == 2" class="active3">
            </div>
            <div style="display:inline-block;margin:0 10px;" v-if="collectType.indexOf('3')!=-1"
              :class="this.JSway == 3?'active1':'active'" @click="YCclick(3)">
              <img src="@/assets/images/money02.png" alt="" style="height:25px;position:absolute;left:5px;top:6px">
              <span style="margin-left:35px">其他</span>
              <!-- <div v-if="this.JSway == 3" class="active2"></div>
              <div v-if="this.JSway == 3" class="active3">√</div> -->
              <img src="@/assets/images/right.png" alt="" style="height:25px;position:absolute;right:-1px;bottom:-1px"
                v-if="this.JSway == 3" class="active3">
            </div>
            <div class="jiesuan">
              <el-input ref="input" v-model="fukuanma" v-on:keyup.13.native='confirmWhOutstockS' />
            </div>
          </el-form-item>
        </el-form>
        <hr>

      </div>
      <div style="width:180px;margin:15px auto;" v-if="this.flagCK == false">
        <el-button type="primary" @click="submitOk" :loading="addLoad">结账</el-button>
        <el-button @click="submitClose">取 消</el-button>
      </div>
      <div style="width:180px;margin:15px auto;" v-else>
        <span>支付中,请稍后......</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getDictionaryJson,
    addEmptyChangeExp,
    addEmptyChangeDaily,
    confirmWhOutstockJanFa,
    getTPerFeeList
  } from '@/api/wms-stock'
  import {
    JfconfirmThreadExp,
    JfunloadConfirm
  } from '@/api/wms-access'
  import DonMessage from '@/utils/message'

  export default {
    name: 'jiesuanDialog',
    data() {
      return {
        isDisable: false,
        flagCK: false,
        loading: false,
        addLoad: false,
        CKFormData: {
          money: 0,
          feeBalance: 0,
          ZHname: '',
          fujiafei: '',
          jianmianfei: '',
          yingshou: 0,
          beizhu: ''
        },
        collectType: '',
        JSway: '3',
        disabledYC: false,
        fukuanma: '',
        message: ''
      }
    },
    props: {
      jiesuanVisible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      },
      titleFlag: {
        type: String
      },
      customer: {
        type: String
      },
      customerTaxid: {
        type: String
      },
      totalFee: {
        type: String
      },
      params: {
        type: Object
      },
      table: {
        type: Array
      }
    },
    methods: {
      fujia() {
        this.$set(this.CKFormData, 'yingshou', (this.CKFormData.feeBalance / 1 + this.CKFormData.fujiafei / 1 - this
          .CKFormData.jianmianfei / 1).toFixed(2))
      },
      jianmian() {
        this.$set(this.CKFormData, 'yingshou', (this.CKFormData.feeBalance / 1 + this.CKFormData.fujiafei / 1 - this
          .CKFormData.jianmianfei / 1).toFixed(2))
      },
      YCclick(val) {
        this.JSway = val
      },
      submitOk() {
        if (this.CKFormData.jianmianfei / 1 > this.CKFormData.feeBalance / 1) {
          this.$message({
            message: '减免费不能超过费用合计',
            type: 'error'
          })
          return
        }
        if (this.JSway == 1 && this.disabledYC) {
          if (this.message == '' && this.CKFormData.yingshou > this.CKFormData.money) {
            this.$message.error('余额不足')
          } else if (this.message != '') {
            this.$message.error(`${this.customer}预存款账户未设置`)
          } else {
            this.flagCK = true
            this.validateOk()
          }
        } else if (this.JSway == 2) {
          this.flagCK = true
          this.fukuanma = ''
          this.$nextTick(() => {
            this.$refs.input.focus()
          })
        } else if (this.JSway == 3) {
          this.flagCK = true
          this.validateOk()
        } else {
          this.$message.error(`请先设置付款方式`)
        }
      },
      validateOk() {
        let jiesuanParams = {
          payMethod: this.JSway,
          allFeeTotal: this.CKFormData.feeBalance,
          receivableFee: this.CKFormData.yingshou,
          additionalFee: this.CKFormData.fujiafei,
          deductionFee: this.CKFormData.jianmianfei,
          feeRemark: this.CKFormData.beizhu
        }
        if (this.title == '结算入库') {
          this.JfconfirmThreadExps(jiesuanParams)
        }
        console.log(this.titleFlag, 'this.titleFlag')
        if (this.title == '结算并转货') {
          if (this.titleFlag == '每日库存') {
            addEmptyChangeDaily({
                ...this.params,
                ...jiesuanParams
              })
              .then(res => {
                DonMessage.success('转货成功')

                this.$emit('colseDialog', false)
              })
              .catch(err => {
                this.Loading = false
                this.flagCK = false

                this.$message({
                  message: err.message,
                  type: 'error'
                })
              })

          }else  if (this.titleFlag !== '每日库存')  {
            this.addEmptyChangeExps(jiesuanParams)

          }
        }
        if (this.title == '结算出库') {
          this.confirmWhOutstockJanFas(jiesuanParams)
        }
      },
      // 结算入库
      JfconfirmThreadExps(jiesuanParams) {
        JfunloadConfirm(this.table)
          .then(res => {
            JfconfirmThreadExp({
                ...this.params,
                ...jiesuanParams
              })
              .then(res => {
                console.log(res)
                this.$emit('colseDialog', false)
              })
              .catch(err => {
                this.flagCK = false
                this.$message({
                  message: err.message,
                  type: 'error'
                })
              })
          })
          .catch(err => {
            this.Loading = false
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      },
      // 结算转货
      addEmptyChangeExps(jiesuanParams) {
        addEmptyChangeExp({
            ...this.params,
            ...jiesuanParams
          })
          .then(res => {
            DonMessage.success('转货成功')

            this.$emit('colseDialog', false)
          })
          .catch(err => {
            this.Loading = false
            this.flagCK = false

            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      },
      // 结算出库
      confirmWhOutstockJanFas(jiesuanParams) {
        confirmWhOutstockJanFa({
            ...this.params,
            ...jiesuanParams
          })
          .then(res => {
            DonMessage.success('出库成功')

            this.$emit('colseDialog', false)
          })
          .catch(err => {
            this.Loading = false
            this.flagCK = false

            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      },
      submitClose() {
        this.$emit('update:jiesuanVisible', false)
      },
      // 扫码结算
      confirmWhOutstockS() {}
    },
    async created() {
      this.CKFormData.feeBalance = Number(this.totalFee).toFixed(2)
      this.CKFormData.yingshou = Number(this.totalFee).toFixed(2)
      // 判断租户开启的结算方式
      const result = await getDictionaryJson({
        groupNo: 'jc_settlement_flag',
        itemNo: window.localStorage.getItem('tenantCode')
      })
      this.collectType = result[0].collectType

      const yucunRes = await getTPerFeeList({
        customerTaxId: this.customerTaxid
      })
      if (yucunRes.length > 0) {
        this.CKFormData.money = yucunRes[0].feeBalance

        this.disabledYC = true
      } else {
        this.CKFormData.money = 0
        this.message = '1'
        this.disabledYC = false
      }
      let a = this.collectType.split(',')
      console.log(a)
      if (!this.disabledYC) {
        this.JSway = a[1]
      } else {
        this.JSway = a[0]
      }
    },
    mounted() {}
  }

</script>

<style lang="less" scoped>
  .active {
    border: 1px solid #e8e8e8;
    margin-bottom: 5px;
    position: relative;
    border-radius: 5px;
    padding-left: 5px;
  }

  .active1 {
    border: 1px solid #106eec;
    margin-bottom: 5px;
    position: relative;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 13px;
  }

  .active2 {
    position: absolute;
    border-style: solid;
    border-width: 10px 10px 10px 10px;
    border-color: #fff #106eec #106eec #fff;
    right: 0;
    bottom: 0;
    border-radius: 0 0 5px 0;
  }

  .jiesuan {
    width: 0;
    height: 0;

    /deep/.el-input {
      width: 0;
      height: 0;
    }

    /deep/.el-input__inner {
      width: 0 !important;
      height: 0 !important;
      border: none !important;
      padding: 0;
      margin: 0;
    }
  }

</style>
